// eslint-disable-next-line import/prefer-default-export
export enum RoutePath {
  Billing = '/billing',
  ChangePassword = '/login/change-password',
  Contacts = '/manage-contacts',
  CreateCategory = '/manage/categories/create',
  CreateItem = '/manage/items/create',
  CreatePromotion = '/manage/promotions/create',
  Dashboard = '/dashboard',
  EditUser = '/manage-users/edit',
  Feedback = '/feedback',
  Help = '/help',
  Home = '/',
  Invoices = '/invoices',
  ItemGrid = '/manage/items',
  ItemTable = '/manage/table',
  Login = '/login',
  Logout = '/logout',
  Manage = '/manage',
  ManageCategories = '/manage/categories',
  ManagePromotions = '/manage/promotions',
  ManualOrder = '/sales/manual-order',
  PreviewItem = '/manage/items/preview',
  Reporting = '/reporting',
  RequestPassword = '/login/reset-password',
  Resources = '/resources',
  Sales = '/sales',
  SearchResults = '/search-results',
  SelectOrganisation = '/select-organisation',
  Settings = '/settings',
  Template = '/template',
  Users = '/manage-users',
  VoucherDetail = '/voucher-detail',
  VoucherDownload = '/voucher-download',
  VoucherRedeem = '/voucher-redeem',
  WebShop = '/web-shop',
}
